import React from 'react';

import classNames from "classnames";
import {StringToJsx} from "../../../../../core/components/string-to-jsx";
import {BettingPromotionModuleButtons} from "./betting-promotion.module.buttons";
import styles from "../styles/betting-promotion.module.scss"

export const BettingPromotionModuleContent = ({controller}) => {
  const {state} = controller;
  const {bookie, disclaimer} = state;
  const {titleText, ctaText} = bookie;

  const contentProps = {
    className: classNames(styles.content),
    style: {color: titleText.textColor}
  }

  return (
    <div {...contentProps}>
      {titleText.text}
      <div className={classNames(styles.bonus)} style={{color: ctaText.textColor}}>
        <StringToJsx domString={ctaText.text.colorSubString(ctaText.highlightedColor)}/>
      </div>
      <BettingPromotionModuleButtons controller={controller}/>
      <div className={classNames(styles.disclaimer)}>{disclaimer}</div>
    </div>
  );
};
